<div class="ap-status">
    <label class="ap-section-label" for="ap-status-select">{{ section.label }}</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="ap-status-field">
        <mat-select
            id="ap-status-select"
            [panelClass]="'gable-select-panel'"
            [value]="value"
            (selectionChange)="onSelectionChange($event.value)"
            [attr.aria-label]="section.label">
            <mat-option
                *ngFor="let option of section.options; trackBy: trackByOptionValue"
                [value]="option.value">
                {{ option.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
